export const arrayBufferToString = (input: ArrayBufferLike): string =>
  //@ts-ignore tsc still has a few issues with the Uint8Array constructor
  String.fromCharCode.apply(null, new Uint8Array(input))

export const arrayBufferToBlob = (input: ArrayBuffer, type?: string): Blob => new Blob([input], { type })

export const stringToArrayBuffer = (input: string): ArrayBufferLike => {
  const buf = new ArrayBuffer(input.length)
  const bufView = new Uint8Array(buf)
  for (let i = 0, strLen = input.length; i < strLen; i += 1) {
    bufView[i] = input.charCodeAt(i)
  }
  return buf
}
